import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { BookingRequest } from '../models/bookingRequest';
import { BookedFormState } from 'Shared/app/enums/BookedFormState';

@Injectable({
  providedIn: 'root'
})
export class BookingRequestService {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = '/api/Engine';

  getBookingRequests(bookingRequestId: string): Observable<BookingRequest> {
    return this.#http.get<BookingRequest>(`${this.#baseUrl}/BookingRequests/${bookingRequestId}`);
  }

  getFormStateFromServer(bookedFormId: string): Observable<BookedFormState> {
    return this.#http.get<BookedFormState>(`${this.#baseUrl}/Forms/GetFormState/${bookedFormId}`);
  }
}